// extracted by mini-css-extract-plugin
export default {"isInactive":"PayeeProductVariant_isInactive__db+zo","bottom":"PayeeProductVariant_bottom__GUaco"};